import { render } from "./CmsEditorButton.vue?vue&type=template&id=67704b7f"
import script from "./CmsEditorButton.vue?vue&type=script&lang=js"
export * from "./CmsEditorButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__